import { render, staticRenderFns } from "./reseverForm.vue?vue&type=template&id=d5bbbdde&scoped=true"
import script from "./reseverForm.vue?vue&type=script&lang=js"
export * from "./reseverForm.vue?vue&type=script&lang=js"
import style0 from "./reseverForm.vue?vue&type=style&index=0&id=d5bbbdde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bbbdde",
  null
  
)

export default component.exports